export type ToggleOptions = {
  trueText: string;
  falseText: string;
  defaultOption?: boolean;
};

export function RadioBool(props: {
  text: string;
  options: ToggleOptions;
  setOptions: (val: boolean) => void;
  id: string;
  wrapperClass?: string;
  titleClass?: string;
  labelClass?: string;
}) {
  const {
    text,
    options,
    setOptions,
    id,
    wrapperClass,
    titleClass,
    labelClass,
  } = props;
  const useDefault: boolean = options.defaultOption !== undefined;
  const handleToggle = (val: boolean) => {
    setOptions(val);
  };
  return (
    <div className={`flex flex-col items-center gap-1 ${wrapperClass}`}>
      <strong>
        <h2 className={`${titleClass}`}>{text}</h2>
      </strong>
      <div className="flex flex-row gap-4">
        <input
          type="radio"
          id={`${id}-true`}
          name={id}
          value="true"
          defaultChecked={useDefault ? options.defaultOption : false}
          onChange={() => handleToggle(true)}
        />
        <label htmlFor={`${id}-true`} className={`${labelClass}`}>
          {options.trueText}
        </label>
        <input
          type="radio"
          id={`${id}-false`}
          name={id}
          value="false"
          defaultChecked={useDefault ? !options.defaultOption : false}
          onChange={() => handleToggle(false)}
        />
        <label htmlFor={`${id}-false`} className={`${labelClass}`}>
          {options.falseText}
        </label>
      </div>
    </div>
  );
}
